import { styled as r } from "styled-components";
import { Theme as o } from "../../../../styles/themes/index.js";
import { ActionsButton as t } from "../../style.js";
const m = r(t)`
  i {
    font-size: 18px;
  }

  color: rgb(${o.colors.Alpha});

  &:hover {
    i {
      color: rgb(${o.colors.Brand});
    }
  }
`, p = r.span`
  margin-right: 6px;
`;
export {
  p as CountText,
  m as LikeButtonContainer
};
